(function () {
  const modal = document.querySelector('[data-digi-kit-modal]');
  if (!modal) return;

  /* ==================================================
     1. DOM / ELEMENTOS BASE
  ================================================== */

  const overlay   = modal.querySelector('.digi-kit-modal-overlay');
  const closeBtns = modal.querySelectorAll('[data-close]');
  const content   = modal.querySelector('.digi-kit-modal-content');

  const cats  = [...modal.querySelectorAll('.digi-kit-modal-category')];
  const items = () => [...modal.querySelectorAll('[data-item]')];

  /* Footer */
  const ctaBtn        = modal.querySelector('[data-checkout]');
  const summaryThumbs = modal.querySelector('[data-digi-summary-thumbs]');
  const subtotalEl    = modal.querySelector('[data-digi-subtotal]');
  const discountEl    = modal.querySelector('[data-digi-discount]');
  const totalEl       = modal.querySelector('[data-digi-total]');
  const clearBtn      = modal.querySelector('[data-clear]');

  /* Progresso */
  const progWrap  = modal.querySelector('[data-progress]');
  const progBar   = modal.querySelector('[data-progress-bar]');
  const progFill  = modal.querySelector('[data-progress-fill]');
  const progCount = modal.querySelector('[data-progress-count]');
  const progLabel = modal.querySelector('[data-progress-label]');

  /* Brinde */
  const reqSection = modal.querySelector('[data-required]');
  const reqCard    = modal.querySelector('[data-required-card]');
  const reqImg     = modal.querySelector('[data-required-img]');
  const reqName    = modal.querySelector('[data-required-name]');
  const reqPrice   = modal.querySelector('[data-required-price]');
  const reqCompare = modal.querySelector('[data-required-compare]');
  const reqBtn     = modal.querySelector('[data-required-btn]');

  const DEBUG_KIT = true;
  function dbg(label, data){
    if (!DEBUG_KIT) return;
    console.groupCollapsed('%c[DIGI KIT] ' + label, 'color:#0ea5e9;font-weight:700;');
    try { console.table(data); } catch(e) { console.log(data); }
    console.groupEnd();
  }


  /* ==================================================
     2. STATE CENTRAL
  ================================================== */

  const cart = new Map();               // key => { title, priceCents, qty, card, isRequired }
  const selectedByCat = new Map(); 
  // catKey => Set(cartKeys)

  let requiredCatConfig = {}; 
  // { whey900: 2, creatina: 1 }

  let currentKitHandle = 'all';

  let comboFixed      = false;
  let kitMax          = 0;

  let visualDiscountPct = 0;
  let visualDiscountAmountCents = 0;

  // 🔒 backups
  let baseDiscountPct = 0;
  let baseDiscountAmountCents = 0;

  let requiredEnabled = false;
  let requiredItem    = null;
  let giftCatKey      = '';

  let giftCueShown = false;

  /* ==================================================
     3. HELPERS GERAIS
  ================================================== */

  const normalizeKey = (s) =>
    String(s || '').toLowerCase().trim().replace(/\s+/g, '');

  const moneyBRLFromCents = (cents) => {
    const v = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + v.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function parseKitList(attr) {
    return String(attr || 'all')
      .split(',')
      .map(normalizeKey)
      .filter(Boolean);
  }

  function resolveItemKitList(itemEl) {
    const own = itemEl.getAttribute('data-kit');
    if (own) return parseKitList(own);

    const cat = itemEl.closest('.digi-kit-modal-category');
    if (cat) return parseKitList(cat.getAttribute('data-kit'));

    return ['all'];
  }

  function resetSummaryUI() {
    if (summaryThumbs) summaryThumbs.innerHTML = '';
    if (subtotalEl) subtotalEl.textContent = moneyBRLFromCents(0);
    if (totalEl) totalEl.textContent = moneyBRLFromCents(0);

    if (discountEl?.parentElement) {
      discountEl.textContent = '';
      discountEl.parentElement.hidden = true;
    }
  }

  function resetProgressUI() {
    if (!progWrap) return;

    if (!comboFixed) {
      progWrap.classList.add('digi-kit-modal-hide');
    } else {
      progWrap.classList.remove('digi-kit-modal-hide');
    }

    if (progFill) progFill.style.width = '0%';
    if (progCount) progCount.textContent = `0/${totalSlotsRequired()}`;

    if (progBar) {
      progBar.setAttribute('aria-valuemax', totalSlotsRequired());
      progBar.setAttribute('aria-valuenow', '0');
    }

    cart.delete('__REQUIRED__');

    if (requiredEnabled && reqSection) {
      reqSection.classList.remove('digi-kit-modal-hide'); // 🔥 mantém visível
      reqSection.classList.add('is-locked');
    }

    if (reqBtn) {
      reqBtn.textContent = requiredItem?.btnLabel || 'BLOQUEADO';
      reqBtn.removeAttribute('disabled');
      reqBtn.classList.remove('is-added');
    }
  }



  /* ==================================================
     4. PROGRESSO / COMBO FIXO
  ================================================== */

  function visibleRequiredCatKeys() {
    if (!comboFixed) return [];

    const kitNorm = normalizeKey(currentKitHandle);
    const giftNorm = normalizeKey(giftCatKey);

    const result = [];

    Object.entries(requiredCatConfig).forEach(([catKey, qty]) => {
      const cat = cats.find(
        c => normalizeKey(c.getAttribute('data-cat')) === catKey
      );
      if (!cat) return;

      if (giftNorm && catKey === giftNorm) return;

      const hasVisible = [...cat.querySelectorAll('[data-item]')].some(i => {
        if (i.classList.contains('digi-kit-modal-hide')) return false;
        const kits = resolveItemKitList(i);
        return kits.includes('all') || kits.includes(kitNorm);
      });

      if (hasVisible) {
        for (let i = 0; i < qty; i++) {
          result.push(catKey);
        }
      }
    });

    return result;
  }


  function totalSlotsRequired() {
    const vis = visibleRequiredCatKeys();
    return vis.length || kitMax || 0;
  }

  function selectedSlots() {
    let total = 0;

    Object.entries(requiredCatConfig).forEach(([catKey, requiredQty]) => {
      const set = selectedByCat.get(catKey);
      if (!set) return;

      total += Math.min(set.size, requiredQty);
    });

    return total;
  }



  function updateProgress() {
    if (!progWrap) return;

    const total = totalSlotsRequired();
    const selected = selectedSlots();

    if (!total) {
      progWrap.classList.add('digi-kit-modal-hide');
      return;
    }

    progWrap.classList.remove('digi-kit-modal-hide');

    const pct = Math.round((selected / total) * 100);
    progFill.style.width = pct + '%';
    progCount.textContent = `${selected}/${total}`;

    progBar.setAttribute('aria-valuemax', total);
    progBar.setAttribute('aria-valuenow', selected);

    progLabel.textContent = 'Adicione 1 sabor de cada linha';

    ensureGiftAutoState();
  }

  function ensureGiftAutoState() {
    if (!requiredEnabled || !requiredItem) {
      cart.delete('__REQUIRED__');
      return;
    }

    const total = totalSlotsRequired();
    const selected = selectedSlots();

    const shouldHaveGift = comboFixed && total > 0 && selected >= total;


    const hasGift = cart.has('__REQUIRED__');

    // 🔥 ATIVA BRINDE
    if (shouldHaveGift && !hasGift) {

      cart.set('__REQUIRED__', {
        title: requiredItem.title,
        priceCents: requiredItem.priceCents,
        qty: 1,
        card: null,
        isRequired: true
      });

      if (reqSection) reqSection.classList.remove('is-locked');

      if (reqBtn) {
        reqBtn.textContent = 'RESGATADO';
        reqBtn.setAttribute('disabled', 'true');
        reqBtn.classList.add('is-added');
      }

      if (!giftCueShown) {
        giftCueShown = true;
        requestAnimationFrame(() => {
          reqSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }


    if (!shouldHaveGift && hasGift) {
      cart.delete('__REQUIRED__');

      giftCueShown = false;

      if (reqSection) reqSection.classList.add('is-locked');

      if (reqBtn) {
        reqBtn.textContent = requiredItem?.btnLabel || 'BLOQUEADO';
        reqBtn.removeAttribute('disabled');
        reqBtn.classList.remove('is-added');
      }
    }
  }



  /* ==================================================
     5. PRICING
  ================================================== */

  function hasValidSelection() {
    return selectedSlots() > 0;
  }


  function computeTotals() {
    if (!hasValidSelection()) {
      return { raw: 0, savings: 0, total: 0 };
    }

    let raw = 0;

    cart.forEach(entry => {
      if (!entry.isRequired) {
        raw += entry.priceCents * entry.qty;
      }
    });

    const total = totalSlotsRequired();
    const selected = selectedSlots();

    const giftAllowed = comboFixed && total > 0 && selected >= total;

    if (giftAllowed && cart.has('__REQUIRED__') && requiredItem) {
      const giftBase =
        Number(requiredItem.compareCents) ||
        Number(requiredItem.priceCents) ||
        0;

      raw += giftBase;
    }

    let savings = 0;

    const discountAllowed = comboFixed && total > 0 && selected >= total;

    if (discountAllowed) {
      if (visualDiscountPct > 0) {
        savings = Math.round(raw * visualDiscountPct / 100);
      } else if (visualDiscountAmountCents > 0) {
        savings = Math.min(raw, visualDiscountAmountCents);
      }
    }

    return {
      raw,
      savings,
      total: Math.max(0, raw - savings)
    };
  }

  /* ==================================================
     6. UI (SUMMARY / FOOTER)
  ================================================== */

  function renderSummary() {
    if (!summaryThumbs) return;
    summaryThumbs.innerHTML = '';

    cart.forEach(entry => {
      if (entry.isRequired && requiredItem) {
        const el = document.createElement('div');
        el.className = 'digi-kit-modal-summary-thumb is-gift';
        el.style.background = requiredItem.cardBg || '#ECFDF5';

        const img = document.createElement('img');
        img.src = requiredItem.image;
        img.alt = requiredItem.title;

        el.appendChild(img);
        summaryThumbs.appendChild(el);
        return;
      }

      if (!entry.card) return;
      const img = entry.card.querySelector('img');
      if (!img) return;

      const el = document.createElement('div');
      el.className = 'digi-kit-modal-summary-thumb';
      el.style.background =
        entry.card.style.getPropertyValue('--bg') || '#F1F3F6';

      el.appendChild(img.cloneNode(true));
      summaryThumbs.appendChild(el);
    });
  }

  function updateFooter() {
    if (!hasValidSelection()) {
      resetSummaryUI();
      updateProgress();
      ctaBtn.disabled = true;
      renderSummary();
      return;
    }

    updateProgress(); // atualiza brinde + progresso

    const reqTotal = totalSlotsRequired();
    const reqSelected = selectedSlots();
    const metaOk = comboFixed && reqTotal > 0 && reqSelected >= reqTotal;

    visualDiscountPct = metaOk ? baseDiscountPct : 0;
    visualDiscountAmountCents = metaOk ? baseDiscountAmountCents : 0;

    // ✅ DEBUG AQUI (ponto perfeito)
    dbg('STATE', {
      comboFixed,
      reqTotal,
      reqSelected,
      metaOk,
      baseDiscountPct,
      baseDiscountAmountCents,
      visualDiscountPct,
      visualDiscountAmountCents,
      cartSize: cart.size,
      hasGift: cart.has('__REQUIRED__'),
      requiredCatConfig,
      giftCatKey
    });


    const totals = computeTotals(); // 👈 não destrutura "total" pra não colidir
    subtotalEl.textContent = moneyBRLFromCents(totals.raw);

    if (discountEl?.parentElement) {
      const showDiscount = totals.savings > 0 && totals.raw > 0;
      discountEl.parentElement.hidden = !showDiscount;
      if (showDiscount) discountEl.textContent = '- ' + moneyBRLFromCents(totals.savings);
    }

    totalEl.textContent = moneyBRLFromCents(totals.total);

    ctaBtn.disabled = comboFixed
      ? reqSelected !== reqTotal
      : cart.size === 0;

    renderSummary();
  }

  /* ==================================================
     7. RESET
  ================================================== */

  function resetUI() {
    items().forEach(card => {
      card.classList.remove('is-selected', 'is-dimmed');
    });

    cart.clear();
    selectedByCat.clear(); // 🔥 ESSENCIAL
    cart.delete('__REQUIRED__');

    resetSummaryUI();
    resetProgressUI();
  }


  /* ==================================================
     8. OPEN / CLOSE
  ================================================== */

  function openForKit(cfg) {

    // 🔥 garante que nunca abre travado
    if (ctaBtn) {
      ctaBtn.disabled = false;
      ctaBtn.classList.remove('is-loading');

      const label = ctaBtn.querySelector('span') || ctaBtn;
      if (label) label.textContent = 'Comprar agora';
    }
    resetUI();

    currentKitHandle = cfg.handle || 'all';

    const kitNorm = normalizeKey(currentKitHandle);

    // filtra itens
    items().forEach(it => {
      const kits = resolveItemKitList(it);
      const show = kits.includes('all') || kits.includes(kitNorm);
      it.classList.toggle('digi-kit-modal-hide', !show);
    });

    // filtra categorias sem itens visíveis
    cats.forEach(cat => {
      const hasVisible = [...cat.querySelectorAll('[data-item]')]
        .some(i => !i.classList.contains('digi-kit-modal-hide'));
      cat.classList.toggle('digi-kit-modal-hide', !hasVisible);
    });

    comboFixed = !!cfg.comboFixed;
    kitMax = cfg.maxItems || 0;

    // guarda o desconto original do kit
    baseDiscountPct = cfg.discountPct || 0;
    baseDiscountAmountCents = cfg.discountAmountCents || 0;

    // começa SEM desconto até bater a meta
    visualDiscountPct = 0;
    visualDiscountAmountCents = 0;

    requiredEnabled = cfg.reqData?.enabled || false;
    requiredItem = cfg.reqData || null;
    requiredCatConfig = cfg.requiredCatConfig || {};
    giftCatKey = cfg.giftCatKey || '';

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    lockScroll(true);

    // ─────────────────────────────────────────
    // ESTADO INICIAL DO BRINDE (SEMPRE VISÍVEL)
    // ─────────────────────────────────────────
    cart.delete('__REQUIRED__');

    if (requiredEnabled && requiredItem && reqSection) {
      // 🔥 MOSTRA a seção
      reqSection.classList.remove('digi-kit-modal-hide');

      // 🔒 estado bloqueado
      reqSection.classList.add('is-locked');

      if (reqImg) reqImg.src = requiredItem.image || '';
      if (reqName) reqName.textContent = requiredItem.title || '';
      if (reqPrice) {
        reqPrice.textContent = moneyBRLFromCents(requiredItem.priceCents || 0);
      }

      if (reqCompare) {
        if (requiredItem.compareCents > requiredItem.priceCents) {
          reqCompare.textContent = moneyBRLFromCents(requiredItem.compareCents);
          reqCompare.classList.remove('digi-kit-modal-hide');
        } else {
          reqCompare.classList.add('digi-kit-modal-hide');
        }
      }

      if (reqBtn) {
        reqBtn.textContent = requiredItem.btnLabel || 'BLOQUEADO';
        reqBtn.removeAttribute('disabled');
        reqBtn.classList.remove('is-added');
      }
    }


    updateFooter();

  }

function close() {
  modal.hidden = true;
  modal.setAttribute('aria-hidden', 'true');
  lockScroll(false);

  // 🔥 RESET DO BOTÃO (ESSENCIAL)
  if (ctaBtn) {
    ctaBtn.disabled = false;
    ctaBtn.classList.remove('is-loading');

    const label = ctaBtn.querySelector('span') || ctaBtn;
    if (label) label.textContent = 'Comprar agora';
  }

  resetUI();
}

  overlay?.addEventListener('click', close);
  closeBtns.forEach(b => b.addEventListener('click', close));
  document.addEventListener('keydown', e => e.key === 'Escape' && close());

  clearBtn?.addEventListener('click', resetUI);

  /* ==================================================
     9. OPEN FROM BUTTON
  ================================================== */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-open-kit]');
    if (!btn) return;

    e.preventDefault();

    const toInt = (v) =>
      parseInt(String(v || '').replace(/[^\d-]/g, ''), 10) || 0;

    const handle = (btn.dataset.openKit || 'all').trim();

    const discountPct = (() => {
      const v = btn.dataset.kitDiscount || '';
      return Number(String(v).replace('%','').replace(',','.')) || 0;
    })();

    const discountAmountCents =
      toInt(btn.dataset.kitDiscountAmountCents);

    const requiredCatConfig = {};

    (btn.dataset.requiredCats || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
      .forEach(entry => {
        const [key, qty] = entry.split(':');
        requiredCatConfig[normalizeKey(key)] = Number(qty) || 1;
      });


    const reqData = {
      enabled: btn.dataset.requiredEnabled === 'true',
      title: btn.dataset.requiredTitle || '',
      variantId: btn.dataset.requiredVariantId || '',
      priceCents: toInt(btn.dataset.requiredPriceCents),
      compareCents: toInt(btn.dataset.requiredCompareCents),
      image: btn.dataset.requiredImage || '',
      btnLabel: btn.dataset.requiredBtnLabel || 'BLOQUEADO',
      cardBg: btn.dataset.requiredCardBg || ''
    };

    openForKit({
      handle,
      maxItems: toInt(btn.dataset.kitMax),
      discountPct,
      discountAmountCents,
      comboFixed: btn.dataset.comboFixed === 'true',
      requiredCatConfig,
      giftCatKey: btn.dataset.giftCat,
      reqData
    });
  });

  /* ==================================================
     10. ITEM CLICK
  ================================================== */
  modal.addEventListener('click', (e) => {
    const card = e.target.closest('.digi-kit-modal-card');
    if (!card) return;

    // 🔒 produto indisponível
    if (card.dataset.available !== 'true') {
      return;
    }

    const catKeyRaw = card.getAttribute('data-cat') || '';
    const catKey = normalizeKey(catKeyRaw); // 🔥 NORMALIZA AQUI
    const variantId = (card.getAttribute('data-variant-id') || '').trim();
    const key = catKey + '__' + variantId;

    let set = selectedByCat.get(catKey);

    if (!set) {
      set = new Set();
      selectedByCat.set(catKey, set);
    }

    if (set.has(key)) {
      set.delete(key);
      cart.delete(key);
      card.classList.remove('is-selected');
    } else {
      if (set.size >= (requiredCatConfig[catKey] || Infinity)) return;

      set.add(key);
      cart.set(key, {
        title: card.getAttribute('data-title'),
        priceCents: Number(card.getAttribute('data-price-cents')) || 0,
        qty: 1,
        card,
        isRequired: false
      });
      card.classList.add('is-selected');
    }


    // 👉 rola automaticamente para a próxima categoria pendente
    if (comboFixed) {
      scrollToNextCategory(catKey);
    }

    updateFooter();
  });

  /* ==================================================
     11. AUTO SCROLL
  ================================================== */
  function scrollToNextCategory(currentCatKey) {
    const pending = visibleRequiredCatKeys()
      .find(k => !selectedByCat.has(k));

    if (!pending) return;

    const nextCat = cats.find(
      c => normalizeKey(c.getAttribute('data-cat')) === pending
    );

    if (nextCat) {
      nextCat.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /* ==================================================
     12. CART DRAWER
  ================================================== */

function openCartDrawer(){
  const btn =
    document.querySelector('[data-open-cart-sidebar]') ||
    document.querySelector('[data-cart-toggle]');

  if (btn){
    btn.click();
    return;
  }

  document.body.classList.add('open-cart-sidebar');
}

ctaBtn?.addEventListener('click', async () => {
  if (ctaBtn.classList.contains('is-loading')) return;

  const items = [];
  const giftEntry = cart.get('__REQUIRED__');
  const bundleId = `${currentKitHandle}:${Date.now()}`;

  cart.forEach(entry => {
    if (entry.isRequired) return;
    if (!entry.card) return;

    const variantId = entry.card.getAttribute('data-variant-id');
    if (!variantId) return;

    items.push({
      id: Number(variantId),
      quantity: entry.qty || 1,
      properties: {
        _bundleId: bundleId,
        _bundleKey: currentKitHandle,
        _bundleStep: `step-${totalSlotsRequired()}`,
        _bundleRole: 'child'
      }
    });
  });

  if (giftEntry && requiredItem?.variantId) {
    items.push({
      id: Number(requiredItem.variantId),
      quantity: 1,
      properties: {
        _bundleId: bundleId,
        _bundleKey: currentKitHandle,
        _bundleStep: `step-${totalSlotsRequired()}`,
        _bundleRole: 'gift'
      }
    });
  }

  // 🔥 VALIDAÇÃO
  if (!items.length) return;

  // 🔥 LOADING
  ctaBtn.disabled = true;
  ctaBtn.classList.add('is-loading');

  const label = ctaBtn.querySelector('span') || ctaBtn;
  const defaultLabel = label ? label.textContent : 'Comprar agora';

  if (label) label.textContent = 'Adicionando...';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        items,
        attributes: {
          _bundleKey: currentKitHandle,
          _bundleStep: `step-${totalSlotsRequired()}`
        }
      })
    });

    if (!res.ok) throw new Error('Erro ao adicionar');

    openCartDrawer();


/*
    // 🔥 EVENTOS (AQUI É O LUGAR CERTO)
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        items: items.map(item => ({
          item_id: item.id,
          quantity: item.quantity
        }))
      }
    });

    window.dataLayer.push({
      event: 'add_to_cart_packs_modal',
      ecommerce: {
        items: items.map(item => ({
          item_id: item.id,
          quantity: item.quantity
        })),
        section: 'packs_modal',
        source: 'modal'
      }
    });
*/


    // 🔥 UPDATE DRAWER
    if (typeof Shopify !== 'undefined' && Shopify.getCart) {
      Shopify.getCart(cart => {
        if (typeof window.updateCart === 'function') {
          window.updateCart(cart);
        }
      });
    }

    // 🔥 FECHA MODAL SUAVE
    setTimeout(() => {
      close();
    }, 300);

  } catch (err) {
    console.error('[DIGI KIT] Erro ao adicionar', err);
  } finally {
    ctaBtn.disabled = false;
    ctaBtn.classList.remove('is-loading');

    if (label) label.textContent = defaultLabel;
  }
});


})();
